module.exports = "/assets/site/images/MVM_vitorlas.jpg?9776330ce52e5e8850acdf2c4fac4fe7";